module.exports = __webpack_public_path__ + "static/img/report_bg3.26a20a30.png";